function showResponseBox()
{
  $('#responseBox').unbind();
  window.recordRTkeys = 1;
  window.enableEnter = trialHasButtonsActive(window.trialRow) ? 0 : 1;
  responseBox.value = '';//clear response box from previous inputs
  buttonsContainers[0].style.display = "block";
  if (!window.inPreviewMode) {
    buttonsContainers[0].focus();
  }
  
  buttonsContainers[0].addEventListener("keydown", saveResponseBoxes, false);
  $('#responseBox').keypress(recordMultipleRT);


  // TODO activate when ready to implement
  // //mutiple input boxes
  // var rowLabels = listTrialResponseRowsLabels[window.trialRow];

  // if (rowLabels) {
  //   labelBox.innerText = rowLabels[0];
  //   labelBox.style.display = 'block';

  //   for (var i = 1; i < rowLabels.length; i++) {
  //      responseBoxesLables[i-1].innerText = rowLabels[i];
  //      responseBoxesLables[i-1].style.display = 'block';
  //      responseBoxes[i-1].value = '';
  //      responseBoxes[i-1].style.display = 'block';
  //   }
  // }
  // // end multiple boxes
}

function recordMultipleRT()
{
  keyRT = Math.round(performance.now() - timeInMs);
	if (recordRTkeys==1)
	{
		if (RTkeys_trial == ''){
			RTkeys_trial = keyRT.toString();
    }
		else {
			RTkeys_trial = RTkeys_trial + ';' + keyRT.toString();
		}
	}
}
